import React from 'react'

import CardPicker from 'src/card_picker/CardPicker'
import { useActions, useMutations } from 'src/hooks'
import { getTotal } from 'src/helpers'
import { CatalogRoute } from 'src/catalog/routes/CatalogRoute'
import AnnouncementBanners from 'src/marketing/AnnouncementBanners/AnnouncementBanners'

type Props = {
  route: CatalogRoute
}

const CatalogPage: React.SFC<Props> = props => {
  const { route } = props
  const actions = useActions()
  const mutations = useMutations()

  const handleCreateOrder = async (cardId: string) => {
    const {
      createOrder: { order },
    } = await mutations.createOrder({ order: { lines: [{ card: cardId }] } })
    actions.openOrder(order.id)
  }

  return (
    <div>
      <AnnouncementBanners />
      <CardPicker
        onCatalogNavigate={actions.openCatalog}
        onAfterSave={handleCreateOrder}
        catalogSubroute={route.subroute}
        saveButtonLabel={'Save & Send'}
        editorSecondaryAction={({ closeEditor }) => ({
          label: 'Save & Close',
          onClick: closeEditor,
        })}
        context={{
          footerLabel: card => <>Total: {getTotal(card.cost)}</>,
        }}
      />
    </div>
  )
}

export default CatalogPage
